import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable no-sparse-arrays, import/max-dependencies */
import cx from 'classnames';
import getAlignSelf from '../getAlignSelf';
import getBorderRadius from '../getBorderRadius';
import getColor, { getTextColor } from '../getColor';
import getFontWeight from '../getFontWeight';
import getFontStyle from '../getFontStyle';
import getHeight, { getMaxHeight } from '../getHeight';
import getPosition from '../getPosition';
import getTextAlign from '../getTextAlign';
import getTextTransform from '../getTextTransform';
import getWidth, { getMaxWidth } from '../getWidth';
import { getTop, getLeft, getRight, getBottom } from '../getPositioning';
import getPadding from '../getPadding';
import getMargin from '../getMargin';
import getFloat from '../getFloat';
import getFlex from '../getFlex';
import getDisplay from '../getDisplay';
import getFontFamily from '../getFontFamily';
import getDecoration from '../getDecoration';
import getZIndex from '../getZIndex';
import { removeEmptyKeys } from '../../utils';
import { combineStyle, createFlexStyle } from './utils';
/**
 * @param {Object} props
 * @param props.alignSelf {import('../getAlignSelf').align}
 * @param props.alignContent {import('../getFlex').alignContent}
 * @param props.alignItems {import('../getFlex').alignItems}
 * @param props.flexDirection {import('../getFlex').flexDirection}
 * @param props.flexWrap {import('../getFlex').flexWrap}
 * @param props.justifyContent {import('../getFlex').justifyContent}
 * @param {string} props.bgColor ,
 * @param {string} props.borderBottomColor,
 * @param {string} props.borderBottomStyle,
 * @param {string|number} props.borderBottomWidth,
 * @param {string} props.borderColor,
 * @param {string} props.borderLeftColor,
 * @param {string} props.borderLeftStyle,
 * @param {string|number} props.borderLeftWidth,
 * @param props.borderRadius {import('../getBorderRadius').radius}
 * @param {string} props.borderRightColor,
 * @param {string} props.borderRightStyle,
 * @param {string|number} props.borderRightWidth,
 * @param {string} props.borderStyle,
 * @param {string} props.borderTopColor,
 * @param {string} props.borderTopStyle,
 * @param {string|number} props.borderTopWidth,
 * @param {string|number} props.borderWidth,
 * @param props.bottom {import('../getPositioning').bottom}
 * @param {string} props.className
 * @param {string} props.color
 * @param props.decoration {import('../getDecoration').decoration}
 * @param props.display {import('../getDisplay').display}
 * @param {string|number} props.flex
 * @param {string|number} props.flexBasis
 * @param {string|number} props.flexGrow
 * @param {string|number} props.flexShrink
 * @param props.float {import('../getFloat').float}
 * @param props.fontWeight {import('../getFontWeight').fontWeight}
 * @param props.fontFamily {import('../getFontFamily').fontFamily}
 * @param props.getFontStyle {import('../getFontStyle').fontStyle}
 * @param props.height {import('../getHeight').height}
 * @param props.maxHeight {import('../getHeight').maxHeight}
 * @param props.left {import('../getPositioning').left}
 * @param props.m {import('../getMargin').m}
 * @param props.mb {import('../getMargin').mb}
 * @param props.ml {import('../getMargin').ml}
 * @param props.mr {import('../getMargin').mr}
 * @param props.mt {import('../getMargin').mt}
 * @param props.mx {import('../getMargin').mx}
 * @param props.my {import('../getMargin').my}
 * @param {number} props.order
 * @param props.p {import('../getPadding').p}
 * @param props.pb {import('../getPadding').pb}
 * @param props.pl {import('../getPadding').pl}
 * @param props.position {import('../getPosition').position}
 * @param props.pr {import('../getPadding').pr}
 * @param props.pt {import('../getPadding').pt}
 * @param props.px {import('../getPadding').px}
 * @param props.py {import('../getPadding').py}
 * @param props.right {import('../getPositioning').right}
 * @param {object} props.style
 * @param props.textAlign {import('../getTextAlign').textAlign}
 * @param props.textTransform {import('../getTextTransform').textTransform}
 * @param props.top {import('../getPositioning').top}
 * @param props.width {import('../getWidth').width}
 * @param props.maxWidth {import('../getWidth').maxWidth}
 * @param props.zIndex {import('../getZIndex').zIndex}
 */

var getSystem = function getSystem(_ref) {
  var alignContent = _ref.alignContent,
      alignItems = _ref.alignItems,
      alignSelf = _ref.alignSelf,
      bgColor = _ref.bgColor,
      borderBottomColor = _ref.borderBottomColor,
      borderBottomStyle = _ref.borderBottomStyle,
      borderBottomWidth = _ref.borderBottomWidth,
      borderColor = _ref.borderColor,
      borderLeftColor = _ref.borderLeftColor,
      borderLeftStyle = _ref.borderLeftStyle,
      borderLeftWidth = _ref.borderLeftWidth,
      borderRadius = _ref.borderRadius,
      borderRightColor = _ref.borderRightColor,
      borderRightStyle = _ref.borderRightStyle,
      borderRightWidth = _ref.borderRightWidth,
      borderStyle = _ref.borderStyle,
      borderTopColor = _ref.borderTopColor,
      borderTopStyle = _ref.borderTopStyle,
      borderTopWidth = _ref.borderTopWidth,
      borderWidth = _ref.borderWidth,
      bottom = _ref.bottom,
      className = _ref.className,
      color = _ref.color,
      decoration = _ref.decoration,
      display = _ref.display,
      flex = _ref.flex,
      flexBasis = _ref.flexBasis,
      flexDirection = _ref.flexDirection,
      flexGrow = _ref.flexGrow,
      flexShrink = _ref.flexShrink,
      flexWrap = _ref.flexWrap,
      float = _ref.float,
      fontFamily = _ref.fontFamily,
      fontStyle = _ref.fontStyle,
      fontWeight = _ref.fontWeight,
      height = _ref.height,
      justifyContent = _ref.justifyContent,
      left = _ref.left,
      m = _ref.m,
      maxHeight = _ref.maxHeight,
      maxWidth = _ref.maxWidth,
      mb = _ref.mb,
      ml = _ref.ml,
      mr = _ref.mr,
      mt = _ref.mt,
      mx = _ref.mx,
      my = _ref.my,
      order = _ref.order,
      p = _ref.p,
      pb = _ref.pb,
      pl = _ref.pl,
      position = _ref.position,
      pr = _ref.pr,
      pt = _ref.pt,
      px = _ref.px,
      py = _ref.py,
      right = _ref.right,
      style = _ref.style,
      textAlign = _ref.textAlign,
      textTransform = _ref.textTransform,
      top = _ref.top,
      width = _ref.width,
      zIndex = _ref.zIndex;

  // getAlignSelf
  var _getAlignSelf = getAlignSelf(alignSelf),
      alignSelfClassName = _getAlignSelf[0]; // getBorderRadius


  var _getBorderRadius = getBorderRadius(borderRadius),
      borderRadiusClassName = _getBorderRadius[0]; // getColor


  var _getColor = getColor(bgColor),
      backgroundColorStyle = _getColor[1];

  var _ref2 = color ? getColor(color) : getTextColor(bgColor),
      colorStyle = _ref2[1];

  var _getColor2 = getColor(borderColor),
      borderColorStyle = _getColor2[1];

  var _getColor3 = getColor(borderTopColor),
      borderColorTopStyle = _getColor3[1];

  var _getColor4 = getColor(borderLeftColor),
      borderColorLeftStyle = _getColor4[1];

  var _getColor5 = getColor(borderRightColor),
      borderColorRightStyle = _getColor5[1];

  var _getColor6 = getColor(borderBottomColor),
      borderColorBottomStyle = _getColor6[1]; // getDecoration


  var _getDecoration = getDecoration(decoration),
      decorationClassName = _getDecoration[0]; // getDisplay


  var _getDisplay = getDisplay(display),
      displayClassName = _getDisplay[0]; // getFloat


  var _getFloat = getFloat(float),
      floatClassName = _getFloat[0]; // getFontFamily


  var _getFontFamily = getFontFamily(fontFamily),
      fontFamilyClassName = _getFontFamily[0]; // getFontStyle


  var _getFontStyle = getFontStyle(fontStyle),
      fontStyleClassName = _getFontStyle[0]; // getFontWeight


  var _getFontWeight = getFontWeight(fontWeight),
      fontWeightClassName = _getFontWeight[0]; // getHeight


  var _getHeight = getHeight(height),
      heightClassName = _getHeight[0],
      heightStyle = _getHeight[1]; // getMaxHeight


  var _getMaxHeight = getMaxHeight(maxHeight),
      maxHeightClassName = _getMaxHeight[0],
      maxHeightStyle = _getMaxHeight[1]; // getFlex


  var _getFlex = getFlex(alignContent, alignItems, flexDirection, flexWrap, justifyContent),
      flexClassName = _getFlex[0],
      flexStyles = _getFlex[1]; // getIcon - not implemented in system
  // getMargin


  var _getMargin = getMargin(m, mb, ml, mr, mt, mx, my),
      marginClassName = _getMargin[0]; // getPadding


  var _getPadding = getPadding(p, pb, pl, pr, pt, px, py),
      paddingClassName = _getPadding[0]; // getPosition


  var _getPosition = getPosition(position),
      positionClassName = _getPosition[0]; // getPositioning


  var _getTop = getTop(top),
      topClassName = _getTop[0];

  var _getBottom = getBottom(bottom),
      bottomClassName = _getBottom[0];

  var _getLeft = getLeft(left),
      leftClassName = _getLeft[0];

  var _getRight = getRight(right),
      rightClassName = _getRight[0]; // getTextAlign


  var _getTextAlign = getTextAlign(textAlign),
      textAlignClassName = _getTextAlign[0]; // getTextAlign


  var _getTextTransform = getTextTransform(textTransform),
      textTransformClassName = _getTextTransform[0]; // getWidth


  var _getWidth = getWidth(width),
      widthClassName = _getWidth[0],
      widthStyle = _getWidth[1]; // getMaxWidth


  var _getMaxWidth = getMaxWidth(maxWidth),
      maxWidthClassName = _getMaxWidth[0],
      maxWidthStyle = _getMaxWidth[1]; // not from system


  var _createFlexStyle = createFlexStyle(flex, flexGrow, flexShrink, flexBasis),
      flexStyle = _createFlexStyle[1]; // getZIndex


  var _getZIndex = getZIndex(zIndex),
      zIndexClassName = _getZIndex[0];

  var classNames = cx(flexClassName, alignSelfClassName, borderRadiusClassName, bottomClassName, decorationClassName, displayClassName, floatClassName, fontFamilyClassName, fontStyleClassName, fontWeightClassName, heightClassName, leftClassName, marginClassName, maxHeightClassName, maxWidthClassName, paddingClassName, positionClassName, rightClassName, textAlignClassName, textTransformClassName, topClassName, widthClassName, zIndexClassName, className // keep className as last
  ) || undefined;
  return [classNames, removeEmptyKeys(_extends({
    backgroundColor: backgroundColorStyle,
    borderLeftColor: combineStyle(borderColorLeftStyle, borderColorStyle),
    borderRightColor: combineStyle(borderColorRightStyle, borderColorStyle),
    borderTopColor: combineStyle(borderColorTopStyle, borderColorStyle),
    borderBottomColor: combineStyle(borderColorBottomStyle, borderColorStyle),
    borderTopStyle: combineStyle(borderTopStyle, borderStyle),
    borderRightStyle: combineStyle(borderRightStyle, borderStyle),
    borderBottomStyle: combineStyle(borderBottomStyle, borderStyle),
    borderLeftStyle: combineStyle(borderLeftStyle, borderStyle),
    borderTopWidth: combineStyle(borderTopWidth, borderWidth),
    borderRightWidth: combineStyle(borderRightWidth, borderWidth),
    borderBottomWidth: combineStyle(borderBottomWidth, borderWidth),
    borderLeftWidth: combineStyle(borderLeftWidth, borderWidth),
    color: colorStyle,
    flex: flexStyle
  }, flexStyles, {
    height: heightStyle,
    maxHeight: maxHeightStyle,
    order: order,
    width: widthStyle,
    maxWidth: maxWidthStyle
  }, style))];
};

export default getSystem;